// Vue
import Vue from 'vue'
import Vuex from 'vuex'
import pathify from '@/plugins/vuex-pathify'

// Modules
import * as modules from './modules'
import firebase from 'firebase'
Vue.use(Vuex)

const fb = require('../firebaseConfig.js')
// fb.auth.onAuthStateChanged(user => {
//   if (user) {
//     store.commit('setCurrentUser', user)
//     store.dispatch('fetchUserProfile')
//     fb.currentUser = user
//   }
// })

const store = new Vuex.Store({

  state: {
    currentUser: null,
    userProfile: {},
    xxschoolPath: "/schools/YJHjHWUGDok8teDhDIKX",
    xxschool:null,
    xxdepartment:null,
  },
  modules,
  plugins: [
    pathify.plugin,
  ],
  actions: {
    clearData({ commit }) {
      commit('setCurrentUser', null)
      commit('setUserProfile', null)
      firebase.auth().signOut().then(() => {
       // this.$router.push("/login");
      })
    },
    fetchUserProfile({ commit, state }) {
      // commit('setCurrentUser', null)
      // commit('setUserProfile', null)
      console.log(state.currentUser)
      if (state.currentUser != null) {
        fb.db
          .collection("/schools/YJHjHWUGDok8teDhDIKX/employees/")
          .where("email", "==", state.currentUser.email)
          .limit(1)
          .get()
          .then(async (datas) => {
            if (!datas.empty) {
              var userDoc = datas.docs[0];
              if (userDoc != null && userDoc.exists) {
                let userData = userDoc.data();
                userData.id = userDoc.id;
                userData.ref = userDoc.ref;
                console.log(userData)
                var sss = await fb.db.doc(state.xxschoolPath).get()
                console.log(sss)
                if(sss.exists){
                  let school = sss.data()
                  school.id = sss.id
                  school.ref = sss.ref
                  state.xxschool = school
                  userData.school = sss
                  console.log(userData.school)
                }
                store.commit("setUserProfile", userData);
                var dep = await userData.departmentRef.get()
                if(dep.exists){
                  let department = dep.data()
                  department.id = dep.id
                  department.ref = dep.ref
                  state.xxdepartment = department
                }
              }
            } else {
              firebase.auth().signOut().then(function () {
                alert("Таны мэдээлэл бүртгэгдээгүй байна!")
                commit('setCurrentUser', null)
                commit('setUserProfile', null)
              }, function (error) {
                commit('setCurrentUser', null)
                commit('setUserProfile', null)
              });

            }
          });
      }

    },
    updateProfile({ commit, state }, data) {
    }
  },
  mutations: {
    setCurrentUser(state, val) {
      state.currentUser = val
    },
    setUserProfile(state, val) {
      state.userProfile = val
    },
  },
  getters: {
    currentUser: state => {
      return state.currentUser
    },
    userProfile: state => {
      return state.userProfile
    },
  },
})

store.subscribe(mutation => {
  if (!mutation.type.startsWith('user/')) return

  store.dispatch('user/update', mutation)
})

store.dispatch('app/init')

export default store

export const ROOT_DISPATCH = Object.freeze({ root: true })
